import { useEffect, useState } from "react";

export const useMatchMedia = (query: string): boolean => {
  const [match, setMatch] = useState<boolean>((): boolean => {
    return window.matchMedia(query).matches;
  });

  useEffect((): () => void => {
    const queryMatch = window.matchMedia(query);
    const updateMatch = (match: MediaQueryListEvent): void => {
      setMatch((): boolean => match.matches);
    };

    // Check to see that addEventListener exists on the media query list.
    // In older Safari versions, there's only addListener/removeListener.
    // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener (see Browser Compatibility list)

    /* eslint-disable @typescript-eslint/no-unnecessary-condition */
    if (!queryMatch.addEventListener) {
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      queryMatch.addListener(updateMatch);
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      return (): void => queryMatch.removeListener(updateMatch);
    } else {
      queryMatch.addEventListener("change", updateMatch);
      return (): void => queryMatch.removeEventListener("change", updateMatch);
    }
    /* eslint-enable */
  }, [query]);

  return match;
};
